module.exports = __webpack_public_path__ + "img/gfgzh.c19575c3.png";